import { render } from "./chujiyaoshi-news.vue?vue&type=template&id=7054b420&scoped=true"
import script from "./chujiyaoshi-news.vue?vue&type=script&lang=js"
export * from "./chujiyaoshi-news.vue?vue&type=script&lang=js"

import "./chujiyaoshi-news.vue?vue&type=style&index=0&id=7054b420&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7054b420"]])

export default __exports__